import type { SupportedFormat } from '@/features/funnel/config/types';

export const FORMAT_MAPPER: Record<SupportedFormat, Intl.NumberFormatOptions> = {
  currency: {
    style: 'currency',
    currency: 'USD',
    maximumFractionDigits: 0,
  },
};
